import { Injectable, inject } from '@angular/core';
import * as access from '../config/access.json';
import Session from '../utils/session.service';
import ServiceRestServices from '../services/service-rest.service';
import FetchingService from '../services/fetching.service';
import BookingsService from '../services/bookings.service';
import AngularHelperService from '../services/angular-helper.service';
import AngularRoutingHelperService from '../services/angular-routing-helper.service';
import AngularStateHelperService from '../services/angular-state-helper.service';
import DictionaryService from './dictionary.service';

@Injectable({ providedIn: 'root' })
export default class RoutingService {
	private session: Session = inject(Session);
	private serviceRestServices: ServiceRestServices = inject(ServiceRestServices);
	private fetchingService: FetchingService = inject(FetchingService);
	private bookingsService: BookingsService = inject(BookingsService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private angularStateHelperService: AngularStateHelperService = inject(AngularStateHelperService);
	private dictionaryService: DictionaryService = inject(DictionaryService);
	
	store: any = {};
	
	getSessionData() {
		var deferred: any = this.angularHelperService.getDeferredPromise();
		const isLoggedIn: any = this.angularStateHelperService.getGlobalProperty('isLoggedIn');
		
		if (!this.angularStateHelperService.getGlobalProperty('session')) {
			this.fetchingService.get('SESSION')
				.then((response) => {
					this.angularStateHelperService.setGlobalProperty('session', response);
					// Ensure the app is treated as "logged in" after a hard refresh on deep routes.
					// Otherwise HeaderComponent.shouldBeVisible() stays false (isLoggedIn=false) and header disappears.
					if (!isLoggedIn && response && response.user) {
						// Prevent duplicate initialization if getSessionData() is called more than once during app startup.
						this.angularStateHelperService.setGlobalProperty('isLoggedIn', true);
						this.session.handleLogin(response, () => deferred.resolve());
						return;
					}
					var locale: any = response && response.user && response.user.deviceLanguage;
					this.dictionaryService.setLanguage(locale).catch(() => {}).finally(() => deferred.resolve());
				})
				.catch(() => {
					deferred.reject();
				});
		} else {
			var session: any = this.angularStateHelperService.getGlobalProperty('session') || {};
			// Same as above: if session is present but the "logged in" flag is not set yet, initialize it.
			if (!isLoggedIn && session && session.user) {
				this.angularStateHelperService.setGlobalProperty('isLoggedIn', true);
				this.session.handleLogin(session, () => deferred.resolve());
				return deferred.promise;
			}
			var locale: any = session.user && session.user.deviceLanguage;
			this.dictionaryService.setLanguage(locale).catch(() => {}).finally(() => deferred.resolve());
		}
		
		return deferred.promise;
	}
	
	getData() {
		var deferred: any = this.angularHelperService.getDeferredPromise();
		var user: any = this.session.getSession() && this.session.getSession().user || {};
		if (user.businessUserType === 'SERVICE_PROVIDER') {
			this.store.bookings = this.bookingsService.getBookings('PAYED');
		}
		
		if (!this.store.dataFetched) {
			if (user.businessUserType === 'SERVICE_PROVIDER') {
				this.serviceRestServices.getServiceByUserId({ userId: user.id }, (service) => {
					this.store.service = service || {};
					this.store.serviceFetched = true;
					if (this.store.bookingsFetched) {
						this.store.dataFetched = true;
						deferred.resolve(this.store);
					}
				});
				this.serviceRestServices.getBookings({ status: 'PAYED' }, (bookings) => {
					this.store.bookings = bookings || [];
					this.store.bookingsFetched = true;
					if (this.store.serviceFetched) {
						this.store.dataFetched = true;
						deferred.resolve(this.store);
					}
				});
			} else {
				this.store.dataFetched = true;
				deferred.resolve(this.store);
			}
		} else {
			deferred.resolve(this.store);
		}
		
		return deferred.promise;
	}
	
	redirectUser(user, name, status?) {
		if (!name) return this.session.resolve().then(() => {this.angularRoutingHelperService.goHome(user); });
		var accessRight: any = access[name];
		if (!accessRight) return this.session.resolve().then(() => { this.angularRoutingHelperService.goHome(user); });
		
		// TODO ANGULAR_2: what is this maddness below???
		
		if (!user.businessUser) {
			var storageBooking: any = window.sessionStorage.getItem('booking');
			var booking: any = storageBooking ? JSON.parse(storageBooking) : {};
			if (booking.service) {
				if (booking.service === 'prescription') {
					window.sessionStorage.removeItem('booking');
//					this.angularRoutingHelperService.setPath('/booking/prescription', false, true);
				}
				if (booking.service === 'instant' && booking.category) {
					window.sessionStorage.removeItem('booking');
//					this.angularRoutingHelperService.setPath('/booking/instant', false, true);
				}
				if (parseInt(booking.service)) {
//					this.angularRoutingHelperService.setPath(['booking/service/', parseInt(booking.service)], false, true);
				}
				return;
			}
		}
		
		switch (user.businessUserType) {
			case 'SERVICE_PROVIDER':
			if (name !== 'sp-settings' && (!status || status === 'INCOMPLETE')) {
//				this.angularRoutingHelperService.setPath('/sp-settings', false, true);
				return;
			}
			if (name === 'home') {
				if (this.store.bookings && this.store.bookings.length) {
//					this.angularRoutingHelperService.setPath('/bookings/unconfirmed', false, true);
				} else {
//					this.angularRoutingHelperService.setPath('/bookings/upcoming', false, true);
				}
				return;
			}
			break;
		}
		
		if (!user.businessUser && !accessRight.allowedRegularUser) return this.session.resolve().then(() => { this.angularRoutingHelperService.goHome(user); });
		if (user.businessUser && accessRight.allowedBusinessUsers.indexOf(user.businessUserType) === -1) return this.session.resolve().then(() => { this.angularRoutingHelperService.goHome(user); });
	}
	
	validateAccess(name) {
		var deferred: any = this.angularHelperService.getDeferredPromise();
		
		this.getSessionData().then(() => {
			var user: any = this.session.getSession() && this.session.getSession().user || {};
			switch (user.businessUserType) {
				case 'SERVICE_PROVIDER':
					this.getData().then((returnedData) => {
						this.redirectUser(user, name, returnedData.service.status);
						this.session.resolve().then(() => {
							deferred.resolve();
						});
					});
					break;
				default:
					this.redirectUser(user, name);
					this.session.resolve().then(() => {
						deferred.resolve();
					});
			}
		});
		
		return deferred.promise;
	}
	
	reset() {
		this.store = {};
		return this.getData();
	}
	
}
